module.exports = __webpack_public_path__ + "2343bc62be3efc9e4a81510713d77f4a.png";